"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const useInternationalizationTranslator_1 = __importDefault(require("../../../hooks/useInternationalizationTranslator"));
const useControlEvents_1 = __importDefault(require("../../../hooks/useControlEvents"));
const useAppAtomStyleFromControlStyle_1 = __importDefault(require("../../../hooks/useAppAtomStyleFromControlStyle"));
const ButtonRenderer = ({ button, }) => {
    const { Render, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const translator = (0, useInternationalizationTranslator_1.default)();
    const getAtomStyle = (0, useAppAtomStyleFromControlStyle_1.default)();
    const events = (0, useControlEvents_1.default)(button);
    (0, useOnLoad_1.default)(button, events);
    const rawContainerStyle = getAtomStyle(button.style || {});
    const { iconConfig } = button;
    const svgIcon = (0, react_1.useMemo)(() => {
        if (!iconConfig || !iconConfig.enabled) {
            return null;
        }
        if (typeof iconConfig.icon === 'string') {
            return (react_1.default.createElement(Render.SvgIcon, { name: iconConfig.icon, family: "material", size: rawContainerStyle.fontSize || 10, color: rawContainerStyle.color || 'white' }));
        }
        if (!iconConfig.icon.name) {
            return null;
        }
        return (react_1.default.createElement(Render.SvgIcon, { name: iconConfig.icon.name, family: iconConfig.icon.family, size: rawContainerStyle.fontSize || 10, color: rawContainerStyle.color || 'white' }));
    }, [iconConfig, rawContainerStyle.fontSize, rawContainerStyle.color, Render]);
    const containerStyle = Object.assign(Object.assign({}, rawContainerStyle), { flexDirection: rawContainerStyle.flexDirection || 'row', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' });
    const iconWrapperStyle = (0, react_1.useMemo)(() => ({
        marginLeft: 10,
        marginRight: 10,
    }), []);
    const Component = (events.onPress || events.onLongPress ? Render.TouchableOpacity : Render.View);
    return (react_1.default.createElement(Component, { style: containerStyle, onPress: events.onPress, onLongPress: events.onLongPress },
        svgIcon && (react_1.default.createElement(Render.View, { style: iconWrapperStyle }, svgIcon)),
        react_1.default.createElement(Render.Text, { style: {
                textDecorationLine: containerStyle.textDecoration || 'none',
                color: containerStyle.color,
                fontSize: containerStyle.fontSize,
                fontWeight: containerStyle.fontWeight || 'normal',
                fontStyle: containerStyle.fontStyle || 'normal',
                flexGrow: 1,
                textAlign: containerStyle.textAlign || 'center',
            } }, translator({
            value: button.label,
            internationalizationValues: button.internationalizationValues,
        }))));
};
exports.default = ButtonRenderer;
